import { Box, Flex, HStack, StackDivider } from '@chakra-ui/react';
import React from 'react';

import Link from '../../Link';

interface UtilitySectionProps {}

interface FindUtilityLinkProps {
  label: string;
  href: string;
}

const FindUtilityLink: React.FC<FindUtilityLinkProps> = ({ label, href }) => (
  <Box flexBasis="auto" flexGrow={0} flexShrink={0}>
    <Link to={href} cursor="pointer" variant="plain">
      {label}
    </Link>
  </Box>
);

const UtilitySection: React.FC<UtilitySectionProps> = () => {
  return (
    <Flex
      direction="row"
      margin={{ laptop: '0 8px 0 0' }}
      padding={{ base: '16px 24px 18px', laptop: '0 16px 0 0' }}
      fontSize="14px"
      lineHeight="19px"
      fontWeight="bold"
      borderBottom={{ base: '1px solid #e5e5e5', laptop: 'none' }}
      height={{ laptop: '48px' }}
    >
      <Flex direction="column">
        <Box padding="0 0 2px" fontSize="11px">
          <span>Find&hellip;</span>
        </Box>
        <HStack
          direction="row"
          margin={0}
          padding={0}
          justify="flex-start"
          listStyleType="none"
          divider={<StackDivider />}
        >
          <FindUtilityLink label="Representative" href="/find/rep/" />
          <FindUtilityLink label="Chapter" href="/find/chapter/" />
        </HStack>
      </Flex>
    </Flex>
  );
};

export default UtilitySection;
